
import Vue from 'vue'
import { MutationTree } from 'vuex'

import { ChatService } from 'messenger/chat/ChatService'
import {
  AlarmItem,
  DashboardTemplate,
  EventItem,
  Message,
  MessageChannel,
  NewsItem,
  StateInterface,
  VehicleStatusLog
} from './state.interface'

export type LocalstorageProperty = { propertyName: string, propertyValue: any }

/*
* Declare reusable mutation names that can be imported anywhere
*/
export const SET_ALARM = 'SET_ALARM'
export const SET_CLUSTER = 'SET_CLUSTER'
export const SET_DASHBOARD = 'SET_DASHBOARD'
export const SET_DM = 'SET_DM'
export const SET_EVENTS = 'SET_EVENTS'
export const SET_LOCALMONITOR = 'SET_LOCALMONITOR'
export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_MESSAGE_CHANNEL = 'SET_MESSAGE_CHANNEL'
export const SET_MONITOR = 'SET_MONITOR'
export const SET_NEWS = 'SET_NEWS'
export const SET_STATUS = 'SET_STATUS'
export const SET_STATUSPLAN = 'SET_STATUSPLAN'
export const SET_UCR = 'SET_UCR'
export const SET_UCR_DEFAULT = 'SET_UCR_DEFAULT'
export const SET_UCR_ACTIVE = 'SET_UCR_ACTIVE'
export const SET_USER = 'SET_USER'

export const SET_JWT = 'SET_JWT'

export const SET_APP_INITIALIZED = 'SET_APP_INITIALIZED'
export const SET_APP_DARKMODE = 'SET_APP_DARKMODE'
export const SET_MONITOR_SORTED_QUALIFICATIONS = 'SET_MONITOR_SORTED_QUALIFICATIONS'
export const SET_ALARM_DASHBOARD_TEMPLATE = 'SET_ALARM_DASHBOARD_TEMPLATE'
export const SET_CURRENT_DASHBOARD_SETTINGS = 'SET_CURRENT_DASHBOARD_SETTINGS'
export const SET_NAV_CUSTOM_TEMPLATE = 'SET_NAV_CUSTOM_TEMPLATE'
export const SET_AUX_NAV_TEMPLATE = 'SET_AUX_NAV_TEMPLATE'
export const SET_VEHICLE_STATUS = 'SET_VEHICLE_STATUS'

export const SET_STORE_MESSAGE = 'SET_STORE_MESSAGE'
export const SET_REMOVE_CHANNEL_FROM_COLLECTION = 'SET_REMOVE_CHANNEL_FROM_COLLECTION'
export const SET_SELECTED_CHANNEL_ID = 'SET_SELECTED_CHANNEL_ID'
export const SET_SELECTED_LAYOUT_INDEX = 'SET_SELECTED_LAYOUT_INDEX'

export const MAX_VEHICLE_STATUS_LOG_LENGTH = 20

export const mutations: MutationTree<StateInterface> = {
  /*** New Mutations ***/
  [SET_ALARM](state: StateInterface, alarmPayload: object) {
    Vue.set(state, 'alarm', alarmPayload)
  },
  [SET_CLUSTER](state: StateInterface, clusterPayload: object) {
    Vue.set(state, 'cluster', clusterPayload)
  },
  [SET_DASHBOARD](state: StateInterface, dashboardPayload: object) {
    Vue.set(state, 'dashboard', dashboardPayload)
  },
  [SET_DM](state: StateInterface, dmPayload: object) {
    Vue.set(state, 'dm', dmPayload)
  },
  [SET_EVENTS](state: StateInterface, eventsPayload: object) {
    Vue.set(state, 'events', eventsPayload)
  },
  [SET_LOCALMONITOR](state: StateInterface, localmonitorPayload: object) {
    Vue.set(state, 'localmonitor', localmonitorPayload)
  },
  [SET_MESSAGE](state: StateInterface, messagePayload: object) {
    Vue.set(state, 'message', messagePayload)
  },
  [SET_MESSAGE_CHANNEL](state: StateInterface, messageChannelPayload: object) {
    Vue.set(state, 'message_channel', messageChannelPayload)
  },
  [SET_MONITOR](state: StateInterface, monitorPayload: object) {
    Vue.set(state, 'monitor', monitorPayload)
  },
  [SET_NEWS](state: StateInterface, newsPayload: object) {
    Vue.set(state, 'news', newsPayload)
  },
  [SET_STATUS](state: StateInterface, statusPayload: object) {
    Vue.set(state, 'status', statusPayload)
  },
  [SET_STATUSPLAN](state: StateInterface, statusplanPayload: object) {
    Vue.set(state, 'statusplan', statusplanPayload)
  },
  [SET_UCR](state: StateInterface, ucrPayload: object) {
    Vue.set(state, 'ucr', ucrPayload)
  },
  [SET_UCR_DEFAULT](state: StateInterface, ucrDefaultPayload: number) {
    state.ucr_default = ucrDefaultPayload
  },
  [SET_UCR_ACTIVE](state: StateInterface, ucrActivePayload: number) {
    state.ucr_active = ucrActivePayload
  },
  [SET_USER](state: StateInterface, userPayload: object) {
    Vue.set(state, 'user', userPayload)
  },

  [SET_APP_INITIALIZED](state: StateInterface, appInitializedPayload: boolean) {
    state.app.initialized = appInitializedPayload
  },
  [SET_APP_DARKMODE](state: StateInterface, appDarkModePayload: boolean) {
    Vue.set(state.app, 'darkMode', appDarkModePayload)
  },
  [SET_MONITOR_SORTED_QUALIFICATIONS](state: StateInterface, monitorSortedQualificationsPayload: Array<any>) {
    Vue.set(state.custom_monitor, 'sortedQualifications', monitorSortedQualificationsPayload)
  },
  [SET_JWT](state: StateInterface, jwtPayload: string) {
    state.jwt = jwtPayload
  },
  [SET_ALARM_DASHBOARD_TEMPLATE ](state: StateInterface, alarmDashboardIdPayload: number) {
    // @ts-ignore
    Vue.set(state.dashboard.selectedTemplate, 'alarmDashboardId', alarmDashboardIdPayload)
  },
  [SET_CURRENT_DASHBOARD_SETTINGS](state: StateInterface, currentDashboardSettingsPayload: DashboardTemplate) {
        // @ts-ignore
    Vue.set(state.dashboard.selectedTemplate, 'settings', currentDashboardSettingsPayload)
  },
  [SET_NAV_CUSTOM_TEMPLATE](state: StateInterface, navCustomTemplatePayload: string) {
    state.navigation.customTemplate = navCustomTemplatePayload
  },
  [SET_AUX_NAV_TEMPLATE](state: StateInterface, auxNavTemplatePayload: string) {
    state.navigation.auxNavTemplate = auxNavTemplatePayload
  },
  [SET_VEHICLE_STATUS](state: StateInterface, vehicleStatusPayload: any) {
    const vehicle = vehicleStatusPayload

    Vue.set(state.cluster.vehicle[vehicle.id], 'fmsstatus_id', vehicle.fmsstatus_id)
    Vue.set(state.cluster.vehicle[vehicle.id], 'fmsstatus_ts', vehicle.fmsstatus_ts)
    Vue.set(state.cluster.vehicle[vehicle.id], 'fmsstatus_note', vehicle.fmsstatus_note)
  },

  /***  Legacy Mutations ***/
  [SET_STORE_MESSAGE](state: StateInterface, message: Message) {
    Vue.set(state.message.items, message.id, message)
  },
  // Append message to channel
  updateMessage(state: StateInterface, message: Message) {
    const messageId = message.id
    const messages = state.message.items
    const isNewMessage = !messages.hasOwnProperty(messageId)

    Vue.set(messages, messageId, message)

    const channelId = message.message_channel_id.toString()

    if (!state.messenger) {
      Vue.set(state, 'messenger', { channels: {} })
    }

    if (!state.messenger.channels[channelId]) {
      Vue.set(state.messenger.channels, channelId, { messageSorting: [] })
    }

    const channel = state.messenger.channels[channelId]

    if (channel.messageSorting.indexOf(messageId) === -1) {
      channel.messageSorting.push(messageId)
    }

    let lastReceivedMessageId = 0

    if (channel.last_message_id) {
      lastReceivedMessageId = channel.last_message_id
    }

    // Update last message index
    if (messageId > lastReceivedMessageId) {
      channel.last_message_id = messageId
    }

    const channelData = state.message_channel.items[channelId]

    // is message newer than what's in the storage?
    if (channelData && (messageId > channelData.last_message_id)) {
      channelData.last_message_id = messageId
      channelData.ts_last_message = message.ts_create

      // mark channel as read if we are the message's author
      // or if the message was added to an currently opened channel
      // ################ ATTENTION ################
      // make sure this state is stored over the API as well! (compare markChannelAsRead)
      if (message.author_id === state.ucr_active || (ChatService.openedChannels.indexOf(message.message_channel_id) > -1)) {
        channelData.self_access.last_message_id = messageId
      }
    }

    // Group up threaded messages
    if (message.parent_id) {
      const parentId = message.parent_id

      if (isNewMessage) {
        if (!channel.messageParents) {
          channel.messageParents = {}
        }
        channel.messageParents[parentId] = (channel.messageParents[parentId] || 0) + 1
      }

      const parentMessage: Message = messages[parentId]

      if (!parentMessage) {
        console.warn(`parent message with id ${parentId} not found (message #${messageId})`)
        return
      }

      if (!parentMessage.messages.includes(messageId)) {
        parentMessage.messages.push(messageId)
      }
    }
  },
  // Append message to channel
  updateMessageChannel(state: StateInterface, messageChannel: MessageChannel) {
    Vue.set(state.message_channel.items, messageChannel.id, messageChannel)
  },
  sortChannelMessages(state: StateInterface, channelId: number) {
    const channel = state.messenger.channels[channelId]
    if (!channel) {
      return
    }
    channel.messageSorting.sort((a, b) => parseInt(a as any, 10) - parseInt(b as any, 10))
  },
  [SET_SELECTED_LAYOUT_INDEX](state: StateInterface, index: number) {
    state.messenger.layout.selectedLayoutIndex = index
  },
  [SET_SELECTED_CHANNEL_ID](state: StateInterface, channelId: number) {
    state.messenger.layout.selectedChannelId = channelId
  },
  [SET_REMOVE_CHANNEL_FROM_COLLECTION](state: StateInterface, channel: MessageChannel) {
    const channelCollection = state.messenger.layout.channelCollection

    for (const columnId in channelCollection) {
      let oldIndex = -1
      let i = 0
      const channels = channelCollection[columnId.toString()]
      const numChannels = channels.length
      for (; i < numChannels; i++) {
        if (channels[i].id !== channel.id) {
          continue
        }
        oldIndex = i
        break
      }
      if (oldIndex !== -1) {
        channelCollection[columnId.toString()].splice(oldIndex, 1)
      }
    }
  },
  addChannelToCollection(state: StateInterface, collectionDetails: { columnId: number, indexInColumn: number, channel: MessageChannel }) {
    const channelCollection = state.messenger.layout.channelCollection
    const { columnId, indexInColumn, channel } = collectionDetails

    if (channelCollection[columnId.toString()]) {
      channelCollection[columnId.toString()].splice(indexInColumn, 0, channel)
    }
  },
  setDashboardTemplates(state: StateInterface, templates: any[]) {
    state.dashboard.templates = templates
  },
  addDashboardTemplate(state: StateInterface, template: DashboardTemplate) {
    if (!template.id) {
      return
    }

    if (!state.dashboard.templates) {
      state.dashboard.templates = []
    }

    const templateId = template.id

    if (state.dashboard.selectedTemplate && state.dashboard.selectedTemplate.id === templateId) {
      state.dashboard.selectedTemplate = template
    }

    const templates = state.dashboard.templates
    const numTemplates = templates.length

    // update template if it already exists
    let i = 0
    for (; i < numTemplates; i++) {
      if (templates[i].id === templateId) {
        Vue.set(templates, i, template)
        return
      }
    }

    // add template if it doesn't exist
    state.dashboard.templates.push(template)
  },
  setSelectedDashboardTemplate(state: StateInterface, template: DashboardTemplate | null) {
    state.dashboard.selectedTemplate = template
  },
  removeDashboardTemplate(state: StateInterface, templateId: number) {
    if (!templateId || !state.dashboard.templates) {
      return
    }

    const templates = state.dashboard.templates
    const numTemplates = templates.length

    let i = 0
    for (; i < numTemplates; i++) {
      const localTemplate = templates[i]
      if (localTemplate.id !== templateId) {
        continue
      }
      templates.splice(i, 1)
      break
    }

    if (state.dashboard.selectedTemplate && state.dashboard.selectedTemplate.id === templateId) {
      state.dashboard.selectedTemplate = null
    }
  },
  updateNewsItem(state: StateInterface, item: NewsItem) {
    if (!state.news.items) {
      state.news.items = {}
    }
    Vue.set(state.news.items, item.id, item)
  },
  updateEventItem(state: StateInterface, item: EventItem) {
    if (!state.events.items) {
      state.events.items = {}
    }
    Vue.set(state.events.items, item.id, item)
  },
  updateAlarmItem(state: StateInterface, item: AlarmItem) {
    if (!state.alarm.items) {
      state.alarm.items = {}
    }
    Vue.set(state.alarm.items, item.id, item)
  },
  initialiseVehicleStatusHistory(state: StateInterface, { items, ts }: any): void {
    const history = state.vehicle_status_history.history

    for (const vehicleId in items) {
      if (!items.hasOwnProperty(vehicleId)) {
        continue
      }

      if (!history[vehicleId]) {
        Vue.set(history, vehicleId, [])
      }

      const cache = history[vehicleId]
      const logfile = items[vehicleId]
      const numLog = logfile.length

      let i = numLog - 1
      for (; i >= 0; i--) {
        const log = logfile[i]
        if (cache.indexOf(log) > -1) {
          return
        }
        cache.unshift(log)
      }

      // the vehicle-status-widget currently displays 20 entries max
      // so we don't need to keep more than that in the cache
      if (cache.length > MAX_VEHICLE_STATUS_LOG_LENGTH) {
        cache.splice(MAX_VEHICLE_STATUS_LOG_LENGTH, cache.length - MAX_VEHICLE_STATUS_LOG_LENGTH)
      }
    }

    state.vehicle_status_history.ts = ts
    state.vehicle_status_history.isInitialised = true
  },
  updateChannelLastMessageDetails(state: StateInterface, { channelId, lastMessageId, tsLastMessage, selfLastMessageId }: any): void {
    const channel = state.message_channel.items[channelId]

    if (!channel) {
      return
    }

    channel.last_message_id = lastMessageId
    channel.ts_last_message = tsLastMessage
    channel.self_access.last_message_id = selfLastMessageId
  },
  updateMessengerChannelCache(state: StateInterface, { channelId, fieldsToUpdate }: any): void {
    const channel = state.messenger.channels[channelId]

    if (!channel) {
      return
    }

    for (const prop in fieldsToUpdate) {
      if (!fieldsToUpdate.hasOwnProperty(prop)) {
        continue
      }
      channel[prop] = fieldsToUpdate[prop]
    }
  },
  deleteMessages(state: StateInterface, { messageIds, keepBereavedParents }: any): void {
    const messages = state.message.items

    if (!messages) {
      return
    }

    const channels = state.messenger.channels

    messageIds.forEach(messageId => {
      if (!messages.hasOwnProperty(messageId)) {
        return
      }

      const message = messages[messageId]

      // remove message from cache
      delete messages[messageId]

      const channel = channels[message.message_channel_id]

      if (!channel) {
        return
      }

      // remove message from sorting
      channel.messageSorting = channel.messageSorting.filter(searchMessageId => searchMessageId !== messageId)

      if (messageId === channel.last_message_id) {
        channel.last_message_id = Math.max(...channel.messageSorting)
      }

      const parentId = message.parent_id

      if (!parentId || !channel.messageParents) {
        return
      }

      let numReferences = (channel.messageParents[parentId] || 0) - 1

      if (numReferences <= 0) {
        delete channel.messageParents[parentId]
        // cascading delete parents that aren't referenced by any messages anymore?
        if (!keepBereavedParents) {
          delete messages[parentId]
        }
        return
      }

      channel.messageParents[parentId] = numReferences
    })
  },
  processVehicleStatusLog(state: StateInterface, vehicle: VehicleStatusLog): void {
    if (!vehicle) {
      return
    }

    const vehicleId = vehicle.id
    const history = state.vehicle_status_history.history

    if (!history[vehicleId]) {
      Vue.set(history, vehicleId, [])
    }

    const cache = history[vehicleId]

    if (cache.indexOf(vehicle) > -1) {
      return
    }

    cache.unshift(vehicle)

    if (cache.length > MAX_VEHICLE_STATUS_LOG_LENGTH) {
      cache.splice(MAX_VEHICLE_STATUS_LOG_LENGTH, cache.length - MAX_VEHICLE_STATUS_LOG_LENGTH)
    }

    const ts = vehicle.ts

    if (ts > state.vehicle_status_history.ts) {
      state.vehicle_status_history.ts = ts
    }
  }
}

export default mutations
